import {
  Card,
  Avatar,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../config/appRoutes";
import ProfileImage from "../../assests/profileImg.jpg";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ProfileTab from "./profileTab";
import FileTab from "./fileTab";
import { useSelector } from "react-redux";
import CircularLoader from "../../components/loaders/circularLoader";
import FormTab from "./formsTab";


export default function UserProfile() {
  const navigate = useNavigate();
  const [value, setValue] = useState('1');
  const { getUserProfile, status } = useSelector((state) => state.contacts);

  const [state, setState] = useState({
    branch_department_id: "",
    branch_department_name: "",
    branch_id: "",
    branch_name: "",
    department_id: "",
    department_name: "",
    email: "",
    id: "",
    mobile: "",
    name: "",
    organization_ids: null,
    organization_names: null,
    qr_code_id: "",
    tag_id: "",
    tag_names: null
  });
 
  useEffect(() => {
    if (getUserProfile?.userdata) {
      setState((prev) => ({
        ...prev,
        ...getUserProfile.userdata,
      }));
    }
  }, [getUserProfile]);

  const hasProfile = !!(getUserProfile && (getUserProfile.userdata || getUserProfile.id));

  useEffect(() => {
    if (status !== 'loading' && !hasProfile) {
      navigate(APP_ROUTES.CONTACT.LIST);
    }
  }, [status, hasProfile, navigate]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Helper to render a value or a muted placeholder
  const renderField = (val) => {
    if (val || val === 0) return val;
    return <span style={{ color: '#6B7280', fontStyle: 'italic' }}>-</span>;
  };


  return (
    <>
      <Card
        sx={{
          maxWidth: "90%",
          mx: "auto",
          mt: 3,
          borderRadius: 3,
          boxShadow: 3,
        }}
      >

        {status === "loading" && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularLoader color="success" />
          </Box>
        )}

        <Grid container spacing={2} columns={12}>
          {hasProfile && (
            <>
              <Grid item size={{ xs: 12, md: 4 }} sx={{ background: 'var(--primary)', boxShadow: "10px 0px 6px 0px rgba(0,0,0,0.06)" }}>

                <Box
                  sx={{
                    position: "relative",
                    p: 2,
                    background: "var(--primary)",
                    boxShadow: "10px 0px 6px 0px rgba(0,0,0,0.06)"
                  }}
                >
                  {/* Back arrow on the left */}
                  <Button
                    onClick={() => navigate(-1)}
                    sx={{
                      position: "absolute",
                      top: 16,
                      left: 16,
                      border: "1px solid black",
                      color: "black",
                      background: "white",
                      minWidth: 0,
                      padding: 1,
                      height: 40,
                      '&:hover': { backgroundColor: 'white', color: 'black' }
                    }}
                  >
                    <ArrowBackIcon sx={{ color: "orangered" }} />
                  </Button>

                  {/* Centered Avatar */}
                  <Box sx={{ display: "flex", justifyContent: "center", pt: 2 }}>
                    <Avatar
                      alt={state?.name || ""}
                      src={state?.profile_image || ProfileImage}
                      sx={{
                        width: 100,
                        height: 100,
                        fontSize: 36,
                        backgroundColor: !state?.profile_image ? 'var(--primary)' : undefined,
                        color: '#fff',
                      }}
                    >
                      {!state?.profile_image && state?.name ? state.name.charAt(0) : null}
                    </Avatar>
                  </Box>
                </Box>

                <Box>
                  <Box sx={{ color: "white", pb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold", display: "flex", justifyContent: "center" }}>{renderField(state?.name)}</Typography>
                    <Typography m={2}><b>Mobile: </b> {renderField(state?.mobile)}</Typography>
                    <Typography m={2}><b>Email :</b> {renderField(state?.email)}</Typography>
                    <Typography m={2}><b>Tags :</b> {renderField(state?.tag_names)} </Typography>
                    <Typography m={2}><b>Branch Name :</b>  {renderField(state?.branch_name)}</Typography>
                    <Typography m={2}><b>Department Name : </b> {renderField(state?.department_name)}</Typography>
                    <Typography m={2}><b>Organization :</b> {renderField(state?.organization_names)}</Typography>
                  </Box>
                </Box>

              </Grid>

              <Grid item size={{ xs: 12, md: 8 }}>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList onChange={handleChange} aria-label="lab API tabs example">
                        <Tab label="Profile" value="1" />
                        <Tab label="Files" value="2" />
                        <Tab label="Forms" value="3" />
                      </TabList>
                    </Box>
                    <TabPanel value="1"><ProfileTab userData={state} /></TabPanel>
                    <TabPanel value="2"><FileTab /></TabPanel>
                    <TabPanel value="3"><FormTab /></TabPanel>
                  </TabContext>
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </Card>
    </>
  );
}
